import React, { CSSProperties, useState } from 'react';
import { Col, Row } from '../../../../lib/utils';
import { Body3Bold, Body3Light, CaptionBold, CaptionRegular, OverlineLight } from '../../../../lib/font';
import dayjs from 'dayjs';
import { colors } from '../../../../lib/colors';
import { I_TODAY_TRIANGLE } from '../../../../types/images';
import styled, { keyframes } from 'styled-components';
import { LEGACY_WEEKLY_BLOCK_HEIGHT } from '../layout';
import ScheduleMemberBadges from '../../ScheduleMemberBadges';

// 애니메이션 정의
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

interface StyledColProps {
    backgroundColor: string;
    isVisible: boolean;
}

// 스타일드 컴포넌트 정의
const HoverItem = styled.div<StyledColProps>`
    width: 300px;
    min-height: 258px;
    padding-bottom: 14px;
    z-index: 99;
    background-color: ${(props) => props.backgroundColor};
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    box-shadow: 4px 4px 8px 0px #0d41a675;
    padding-left: 16px;
    padding-right: 24px;
    padding-top: 14px;
    transition: all 1s ease;
    animation: ${(props) => (props.isVisible ? fadeIn : 'none')} 1s ease forwards;
    position: absolute;
`;

const GroupScheduleBlock = ({ childArr, cellIndex, onClickSchedule }: any) => {
    const [showModal, setShowModal] = useState(false);
    const isGoingSchedule = dayjs().isAfter(childArr[0].startTime) && dayjs().isBefore(childArr[0].endTime);
    const [showDetailModalArr, setShowDetailModalArr] = useState(Array.from({ length: childArr.length }, () => false));

    const hoverStyle: CSSProperties =
        cellIndex > 5
            ? {
                  //   marginTop: '-40%',
                  //   marginRight: '156.2%',
                  right: '110%',
              }
            : {
                  //   marginTop: '-40%',
                  //   marginRight: '-156.2%',
                  left: '110%',
              };

    return (
        <Row
            style={{
                width: '95%',
                height: LEGACY_WEEKLY_BLOCK_HEIGHT,
                cursor: 'pointer',
                marginBottom: 4,
                justifyContent: 'space-between',
                backgroundColor: colors.WHITE_50,
                position: 'relative',
            }}
            onMouseEnter={() => setShowModal(true)}
            onMouseLeave={() => setShowModal(false)}
        >
            {childArr &&
                childArr.map((item: any, index: number) => {
                    const coachName = item?.coachName;
                    const alias = item?.alias;

                    return (
                        <Col
                            key={'innerScheduleBoxArr' + index}
                            style={{
                                width: '48%',
                                height: LEGACY_WEEKLY_BLOCK_HEIGHT,
                                borderRadius: 4,
                                backgroundColor: colors.WHITE_50,
                                alignItems: 'flex-start',
                                justifyContent: 'center',
                                border: isGoingSchedule ? '1.5px solid #3D73DD' : '1.5px solid #648FE4',
                                cursor: 'pointer',
                                boxShadow: showDetailModalArr[index] ? '0px 0px 12px 0px #3D73DD52' : '',
                                position: 'relative',
                                padding: 5,
                            }}
                            onMouseEnter={() => {
                                const arr = Array.from({ length: childArr.length }, () => false);
                                arr[index] = true;
                                setShowDetailModalArr(arr);
                            }}
                            onMouseLeave={() => {
                                const arr = Array.from({ length: childArr.length }, () => false);
                                setShowDetailModalArr(arr);
                            }}
                            onClick={() => {
                                onClickSchedule(childArr[index]);
                            }}
                        >
                            <Row
                                style={{
                                    width: '100%',
                                    justifyContent: 'flex-end',
                                    marginLeft: 12,
                                }}
                            >
                                {isGoingSchedule && (
                                    <img
                                        style={{
                                            position: 'absolute',
                                            width: 24,
                                            height: 18,
                                            top: 0,
                                        }}
                                        src={I_TODAY_TRIANGLE}
                                        alt=""
                                    />
                                )}
                            </Row>
                            <Col
                                style={{
                                    width: '100%',
                                    height: 34,
                                    justifyContent: 'space-between',
                                    overflow: 'hidden',
                                }}
                            >
                                {!coachName ? null : coachName.length <= 3 ? (
                                    <CaptionBold
                                        style={{
                                            textAlign: 'left',
                                            color: colors.LAVEL_3,
                                            lineHeight: '16px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        {coachName} 강사
                                    </CaptionBold>
                                ) : (
                                    <CaptionBold
                                        style={{
                                            textAlign: 'left',
                                            color: colors.LAVEL_3,
                                            lineHeight: '16px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                    >
                                        {coachName} 강사
                                    </CaptionBold>
                                )}
                                <Row style={{ width: '100%', minWidth: 0, alignItems: 'center', gap: 4 }}>
                                    <CaptionBold
                                        style={{
                                            textAlign: 'left',
                                            color: colors.LAVEL_3,
                                            lineHeight: '15px',
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            minWidth: 0,
                                            flex: 1,
                                        }}
                                    >
                                        {alias}
                                    </CaptionBold>
                                    <OverlineLight
                                        style={{
                                            textAlign: 'left',
                                            color: colors.LAVEL_3,
                                            lineHeight: '15px',
                                            whiteSpace: 'nowrap',
                                            flexShrink: 0,
                                        }}
                                    >
                                        {dayjs(item?.startTime).format('HH:mm')}
                                    </OverlineLight>
                                </Row>
                            </Col>
                            {/* 우측 하단에 노쇼를 의미하는 빨간 점 추가 */}
                            {item.attendanceStatus === 'NOSHOW' && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        width: '8%',
                                        aspectRatio: 1,
                                        backgroundColor: colors.ERROR,
                                        borderRadius: '50%',
                                        bottom: 8,
                                        right: 8,
                                    }}
                                />
                            )}

                            {/* 우측 하단에 노쇼를 의미하는 빨간 점 추가 */}
                            {item?.postId !== '' && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        width: '8%',
                                        aspectRatio: 1,
                                        backgroundColor: colors.BLUE_500,
                                        borderRadius: '50%',
                                        bottom: 8,
                                        right: item?.attendanceStatus === 'NOSHOW' ? 20 : 8,
                                    }}
                                />
                            )}
                        </Col>
                    );
                })}

            {showModal && (
                <HoverItem style={hoverStyle} backgroundColor={colors.WHITE_50} isVisible={showModal}>
                    <Row
                        style={{
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Row style={{ width: 200 }}>
                            <Col
                                style={{
                                    width: 8,
                                    height: 22,
                                    borderRadius: 8,
                                    backgroundColor: colors.BLUE_500,
                                    marginRight: 11,
                                }}
                            />
                            <Body3Bold style={{ color: colors.LAVEL_3 }}>{`${childArr[0]?.coachName} 강사`}</Body3Bold>
                        </Row>
                        {childArr[0]?.attendanceStatus === 'NOSHOW' ? (
                            <Row
                                style={{
                                    width: 64,
                                    height: 23,
                                    borderRadius: 34,
                                    border: '1px solid #FF3E4A',
                                    color: colors.red,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <CaptionBold>노쇼</CaptionBold>
                            </Row>
                        ) : (
                            <Row
                                style={{
                                    width: 64,
                                    height: 23,
                                    borderRadius: 34,
                                    border: '1px solid #3D73DD',
                                    color: colors.BLUE_500,
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <CaptionBold>
                                    {isGoingSchedule
                                        ? '수업중'
                                        : dayjs().isAfter(childArr[0]?.endTime)
                                          ? '수업 완료'
                                          : '수업 예정'}
                                </CaptionBold>
                            </Row>
                        )}
                    </Row>

                    <Body3Light style={{ color: colors.LAVEL_3, marginTop: 16 }}>
                        {dayjs(childArr[0]?.startTime).format('M월 D일(ddd)')}
                    </Body3Light>

                    <Body3Bold style={{ color: colors.LAVEL_3, marginTop: 8 }}>
                        {dayjs(childArr[0]?.startTime).format('A hh:mm ~ ')}
                        {dayjs(childArr[0]?.endTime).format('A hh:mm ')}
                        {`(${childArr[0]?.duration}분)`}
                    </Body3Bold>

                    <Row style={{ alignItems: 'center', marginTop: 8 }}>
                        <Body3Bold style={{ color: colors.LAVEL_3 }}>{childArr[0]?.alias} 회원</Body3Bold>
                        <Body3Light style={{ color: colors.LAVEL_2, marginLeft: 16 }}>{`${
                            childArr[0]?.currentSession ? childArr[0]?.currentSession : '?'
                        }/${childArr[0]?.totalSession ? childArr[0]?.totalSession : '?'}회`}</Body3Light>
                    </Row>
                    <CaptionRegular style={{ color: colors.LAVEL_2, marginTop: 8 }}>
                        수강권 : {childArr[0]?.membership ? childArr[0]?.membership?.name : '-'}
                    </CaptionRegular>
                    <ScheduleMemberBadges schedule={childArr[0]} style={{ marginTop: 6 }} />

                    <Row style={{ alignItems: 'center', marginTop: 8 }}>
                        <Body3Bold style={{ color: colors.LAVEL_3 }}>{childArr[1]?.alias} 회원</Body3Bold>
                        <Body3Light style={{ color: colors.LAVEL_2, marginLeft: 16 }}>{`${
                            childArr[1]?.currentSession ? childArr[1]?.currentSession : '?'
                        }/${childArr[1]?.totalSession ? childArr[1]?.totalSession : '?'}회`}</Body3Light>
                    </Row>
                    <CaptionRegular style={{ color: colors.LAVEL_2, marginTop: 8 }}>
                        수강권 : {childArr[1]?.membership ? childArr[1]?.membership?.name.substr(0, 40) : '-'}
                    </CaptionRegular>
                    <ScheduleMemberBadges schedule={childArr[1]} style={{ marginTop: 6 }} />
                </HoverItem>
            )}
        </Row>
    );
};

export default GroupScheduleBlock;
